import { render, staticRenderFns } from "./ListApartments.vue?vue&type=template&id=67f01a3c"
import script from "./ListApartments.vue?vue&type=script&lang=js"
export * from "./ListApartments.vue?vue&type=script&lang=js"
import style0 from "./ListApartments.vue?vue&type=style&index=0&id=67f01a3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports